import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IQuestionSubType } from "../../../Pages/QuestionSubType/IQuestionSubType";

export const ListQuestionSubTypeSlice = createSlice({
  name: "ListQuestionSubTypeSlice",
  initialState: {} as IReduxState<IQuestionSubType[]>,
  reducers: {
    listQuestionSubType: (state, _: PayloadAction<IQuestionSubType>) => {
      state.isLoading = true;
    },
    successlistQuestionSubType: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistQuestionSubType: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearlistQuestionSubTypeResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  failurelistQuestionSubType,
  listQuestionSubType,
  successlistQuestionSubType,
  clearlistQuestionSubTypeResponse,
} = ListQuestionSubTypeSlice.actions;

export default ListQuestionSubTypeSlice.reducer;
